import { SEOHead } from '../components/SEOHead';
import { AppNavigationBar } from '../components/AppNavigationBar';
import { User, Bell, Shield, LogOut } from 'lucide-react';

export default function AppSettings() {
  return (
    <div className="relative w-full h-screen bg-[var(--color-white)]">
      <SEOHead title="Einstellungen – pixcapture.app" description="App-Einstellungen" path="/app/settings" />
      
      <div className="p-6 pb-24">
        <h1 className="text-[24px] mb-6">Einstellungen</h1>

        <div className="space-y-4">
          <button className="w-full flex items-center gap-4 p-4 border border-[var(--color-light-grey)] rounded-md hover:bg-gray-50">
            <User className="h-6 w-6 text-[var(--color-accent)]" />
            <span>Profil</span>
          </button>

          <button className="w-full flex items-center gap-4 p-4 border border-[var(--color-light-grey)] rounded-md hover:bg-gray-50">
            <Bell className="h-6 w-6 text-[var(--color-accent)]" />
            <span>Benachrichtigungen</span>
          </button>

          <button className="w-full flex items-center gap-4 p-4 border border-[var(--color-light-grey)] rounded-md hover:bg-gray-50">
            <Shield className="h-6 w-6 text-[var(--color-accent)]" />
            <span>Datenschutz</span>
          </button>

          <button className="w-full flex items-center gap-4 p-4 border border-red-300 rounded-md hover:bg-red-50 text-red-600">
            <LogOut className="h-6 w-6" />
            <span>Abmelden</span>
          </button>
        </div>
      </div>

      <AppNavigationBar activeRoute="/app/settings" />
    </div>
  );
}
